import AdminLayout from 'components/templates/AdminLayout';
import Subscription from 'components/UI/organisms/subscription/Subscription';

const SubscriptionPage = () => {
  return <AdminLayout title={'예진 사용 현황'} content={<Subscription />} sideType={0} />;
};

export default SubscriptionPage;
